module.exports = __webpack_public_path__ + "static/media/depositar.6aa63e16.svg";